import AxiosInstance from "./api";

export const GoodsDeliveryNoteService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/goods-delivery-note", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/goods-delivery-note/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/goods-delivery-note", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/goods-delivery-note/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/goods-delivery-note/${id}`);
  },
};
